jQuery( document ).ready( $ => {
	$( '.elementor-form' ).on( 'submit_success', (event, response) => {
		if( response?.data?.whippet_gtm_event ) {
			window.dataLayer = window.dataLayer || [];
			
			window.dataLayer.push( response.data.whippet_gtm_event );
		}
	} );
} );
